import axios from "axios";
// REACT_APP_* variables from .env are injected by react-scripts at build time (dotenv is Node-only)

// import {UserManager} from "oidc-client";
// import OpenIdConnectClientConfig from "./open-id-configuration";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

// const baseURL = "https://cors-anywhere.herokuapp.com/http://eb43a952.ngrok.io/api/";
// const baseURL = "http://157.230.38.16:8080/api/";
//http: 157.230.38.16:8082/api/v1
const baseURL = `${process.env.REACT_APP_API_URL}`;
const auth_username = process.env.REACT_APP_USERNAME;
const auth_password = process.env.REACT_APP_PASSWORD;

const getAuth = () => {
  let accessToken = localStorage.getItem("access_token");

  if (accessToken) {
    return `Bearer ${accessToken}`;
  }

  return "";
};

const BasicAuth =
  "Basic " + window.btoa(unescape(encodeURIComponent(`${auth_username}:${auth_password}`))); // Buffer is Node-only (no polyfill in react-scripts 5)

export const _fetch = async (
  url,
  options = {
    method: "GET",
    body: {},
  },
  useBasicAuth = false
) => {
  const authorization = useBasicAuth ? BasicAuth : getAuth();
  const request = {
    method: options.method,
    baseURL,
    url,
    headers: {
      Authorization: authorization,
      "Content-Type": "application/json",
    },
  };

  if (request.method === "POST" || request.method === "PUT" || request.method === "DELETE") {
    request.data = options.body;
  }

  try {
    const res = await axios(request, { cancelToken: source.token });

    if (res.status >= 200 && res.status < 400) {
      return res;
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("access_token");
      window.location = `/login`;
    }
    throw error;
  }
};
